import { PickList as PickLists } from 'primereact/picklist';  

const PickList = ({...rest}) => {

    return (
        <PickLists {...rest} />
    )

};

export default PickList;